export default __webpack_public_path__ + "static/media/logo.3268d881.svg";